import React from 'react'
import { Transition } from 'semantic-ui-react'

export default function SelectedPreferences({ selectedPreferences }) {
  return (
    <div className="flex flex-wrap gap-3 justify-start">
      <Transition.Group animation="fade up" duration={300}>
        {selectedPreferences.map((item) => (
          <div key={item.id}>
            <SelectedPreference
              key={item.id}
              title={item.name}
              emojiIcon={item.emoji_icon}
              image={item.image}
            />
          </div>
        ))}
      </Transition.Group>
    </div>
  )
}

function SelectedPreference({ title, emojiIcon, image }) {
  return (
    <div className="selected-preference">
      {image ? (
        <div className="flex items-center gap-1">
          <img key={`${title}-image`} src={image} width={24} alt={title} />
          <span>{title}</span>
        </div>
      ) : (
        <div className="flex flex-row items-center gap-1">
          <div className="text-lg mr-1">{emojiIcon} </div> {title}
        </div>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SelectedPreferences/index.js